import React from "react";

interface IChatIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const ChatIcon: React.FC<IChatIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
             aria-hidden="true">
            <path
                d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path>
        </svg>
    );
};
